import serialize from 'form-serialize';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Alert, Button, Col, Form, Modal,
} from 'react-bootstrap';
import { api } from '../../api';

export class AddAnswerType extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      validated: false,
      formError: null,
    };
  }

  handleSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const validated = form.checkValidity();
    const obj = serialize(form, { hash: true });

    if (validated === false) {
      event.stopPropagation();
    } else {
      this.addAnswerType(obj, validated);
    }
    this.setState({ validated: true });
    event.stopPropagation();
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  errorAlert = (error) => {
    this.setState({
      formError: error,
    });
    setTimeout(() => {
      this.setState({
        formError: null,
      });
    }, 5000);
  };

  addAnswerType(obj, validated) {
    if (validated === true) {
      const data = {
        title: obj.title,
        value: obj.value,
        disabled: !(!obj.disabled || obj.disabled !== 'on'),
        isDefault: !(!obj.isDefault || obj.isDefault !== 'on'),
      };

      // eslint-disable-next-line react/destructuring-assignment
      if (this.props.data !== null) {
        // eslint-disable-next-line react/destructuring-assignment
        api.put(`/v1/answers/types/${this.props.data.id}`, data)
          .then(() => {
            // eslint-disable-next-line react/destructuring-assignment
            this.props.update();
          })
          .catch((error) => {
            this.errorAlert(error.response.data.error);
          });
      } else {
        api.post('/v1/answers/types', data)
          .then(() => {
            // eslint-disable-next-line react/destructuring-assignment
            this.props.update();
          })
          .catch((error) => {
            this.errorAlert(error.response.data.error);
          });
      }
    }
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.props.show) {
      return null;
    }

    const { validated } = this.state;
    let title = 'Add New Answer Type';
    let defTitle = '';
    let defValue = '';
    let defDisabled = false;
    let defIsDefault = false;
    const { data } = this.props;
    if (data !== null && data.title) {
      title = `Edit Answer Type ${data.title}`;
      defTitle = data.title;
      defValue = data.value;
      defDisabled = data.disabled;
      defIsDefault = data.isDefault;
    }

    const { update, onHide, ...other } = this.props;
    const { formError } = this.state;
    return (
      <Modal
        {...other}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => this.handleSubmit(e)}
        >
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Col md={12} className={formError === null ? 'd-none' : 'd-block'}>
              <Alert variant="danger">
                {formError}
              </Alert>
            </Col>

            <Form.Row>
              <Form.Group as={Col} md="4" controlId="Title">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Title"
                  defaultValue={defTitle}
                  name="title"
                />
                <Form.Control.Feedback type="invalid">
                  Please choose Title.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="Value">
                <Form.Label>ID</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="ID"
                  defaultValue={defValue}
                  name="value"
                />
                <Form.Control.Feedback type="invalid">
                  Please choose ID.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="2" controlId="Value">
                <Form.Label>Default</Form.Label>
                <Form.Check
                  custom
                  id="isDefault"
                  name="isDefault"
                  defaultChecked={defIsDefault}
                  label=""
                />
              </Form.Group>
              <Form.Group as={Col} md="2" controlId="Value">
                <Form.Label>Disabled</Form.Label>
                <Form.Check
                  custom
                  id="disabled"
                  name="disabled"
                  defaultChecked={defDisabled}
                  label=""
                />
              </Form.Group>

            </Form.Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="reset"
              variant="secondary"
              onClick={() => onHide()}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              variant="primary"
            >
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

AddAnswerType.propTypes = {
  onHide: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
};
